import Vue from 'vue';
/**
 * Dialog Component State Mixin
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.6.0}
 */
export default Vue.extend({
    data() {
        return {
            toggle: false,
        };
    },
    methods: {
        showDialog() {
            this.toggle = true;
        },
        hideDialog() {
            this.toggle = false;
        },
    },
});
